<template>
  <div>
    <b-container>
      <div class="row pt-3">
        <div class="col">
          <img src="./../../../assets/web/img/logo-pgj.png" alt="large" />
        </div>
        <div class="col d-none d-sm-block">
          <a href="#/login" class="float-right pt-3">
            已有账户？请登录>
          </a>
        </div>
      </div>
    </b-container>
    <b-container
      fluid
      class="my-2 bg-light"
      style="border-bottom: 1px solid #eee; border-top: 1px solid #eee;"
    >
        <div class="container pt-4" >
            <form class="py-1" style="max-width: 500px;margin: 0 auto;">
              <validation-observer ref="userResetForm">
                <h4 class="pb-4">重置密码<br>
                <small class="text-muted"><small>忘记密码后，重新设置您的新密码</small></small>
                </h4>
                <div id="alert"></div>

                <validation-provider
                    :rules="{required:true, regex:/1[3|4|5|7|8][0-9]\d{8}/}"
                    name="手机号"
                    v-slot="validationContext"
                    >
                    <b-form-group label="手机号:" label-cols="4" :invalid-feedback="validationContext.errors[0]" >
                        <b-form-input 
                            name="field"
                            v-model="userResetDto.mobile" 
                            :state="validateState(validationContext)"
                            placeholder="手机号">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    :rules="{required:true, min:6, max:20, regex:/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/}"
                    name="新密码"
                    v-slot="validationContext"
                    vid="newPassword1"
                    >
                    <b-form-group label="新密码:" label-cols="4" :invalid-feedback="validationContext.errors[0]" >
                        <b-form-input 
                            name="field"
                            v-model="userResetDto.password" 
                            :state="validateState(validationContext)"
                            type="password"
                            placeholder="字母数字组合,6到20个字符">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    :rules="{required:true, confirmed: 'newPassword1'}"
                    name="确认密码"
                    v-slot="validationContext"
                    >
                    <b-form-group label="确认密码:" label-cols="4" :invalid-feedback="validationContext.errors[0]" >
                        <b-form-input 
                            name="field"
                            v-model="userResetDto.passwordConfirm" 
                            :state="validateState(validationContext)"
                            type="password"
                            placeholder="确认密码">
                        </b-form-input>
                    </b-form-group>
                </validation-provider>

                <validation-provider
                    name="验证码"
                    v-slot="validationContext"
                    >
                    <b-form-group label="验证码:" label-cols="4" :invalid-feedback="validationContext.errors[0]" >
                        <b-input-group>
                            <b-form-input 
                                name="field"
                                ref="veriCodeInput"
                                v-model="userResetDto.verificationCode" 
                                :state="validateState(validationContext)"
                                type="password"
                                placeholder="验证码">
                            </b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!canClick" variant="info" @click="openVerify">{{content}}</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </validation-provider>

                <div class="form-group row">
                    <div class="col-md-12">
                        <button type="button" @click="handleReset" class="btn btn-danger btn-block">重置密码</button>
                    </div>
                </div>
              </validation-observer>
            </form>

        </div>
    </b-container>

    <b-modal
      id="verifyModal"
      ref="modal-verify"
      v-model="verifyVisible"
      centered
      size="md"
      hide-footer
      style="max-width:200px"
      title="请完成以下拼图验证"
    >
      <!-- :imgSize="{ width: '470px', height: '250px' }" -->
      <Verify @success="handelGetVerifyCode" :mode="'fixed'" :captchaType="'blockPuzzle'" ref="verify" />
    </b-modal>
  </div>
</template>

<script>
import * as userFacade from "../../../api/user-facade.js";
import Verify from "@/components/captcha/Verify.vue";

export default {
  components: {
    Verify
  },
  // validations:
  data() {
    return {
        userResetDto:{},
        content: '发送验证码',
        totalTime: 60,
        canClick: true, //添加canClick
        verifyVisible: false,
    };
  },

  created() {},
  mounted() {
      
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    openVerify() {
      this.$refs.userResetForm.validate().then(valid => {
        if (valid) {
          //let param = { captchaVerification: "11" };
          //this.handleLogin(param);
          this.verifyVisible = true;
        } else {
          // 登录表单校验失败
          this.$message({
            message: "请填写正确的信息",
            type: "danger"
          });
        }
      });
    },
    // 获取验证码
    handelGetVerifyCode(params){
        this.verifyVisible = false;
        this.userResetDto.captchaVerification = params.captchaVerification;
        userFacade
            .getResetVeriCode(this.userResetDto)
            .then(()=>{
              this.countDown()
            })
            .catch(err => {
              console.log("err", err);
            });
    },
    // 注册
    handleReset(){
      this.$refs.userResetForm.validate().then(valid => {
        if (valid) {
            // 判断校验码是否录入
            if(this.userResetDto.verificationCode == null){
                    this.$message({
                        message: "输入验证码",
                        type: "danger"
                    });
                    this.$refs.veriCodeInput.focus();
                    return
            }

            // 执行用户注册
            userFacade
            .resetPassword(this.userResetDto)
            .then(()=>{
              this.$message({
                message: "密码重置成功，请用新密码进行登录",
                type: "success"
              });
              this.resetForm();              

              // 跳转到登录页面进行登录
              let var1 = this;
              setTimeout(function() {
                var1.$router.replace("/login")
              }, 3000);

            })
            .catch(err => {
              console.log("err", err);
              this.pageLoading = false;
            });
        }
      })
    },
    // 充值表单
    resetForm() {
      this.userResetDto = {      };

      this.$nextTick(() => {
        this.$refs.userResetForm.reset();
      });
    },

    countDown () {
        if (!this.canClick) return //改动的是这两行代码
        this.canClick = false
        this.content = this.totalTime + 's'
        let clock = window.setInterval(() => {
            this.totalTime--
            this.content = this.totalTime + 's'
            if (this.totalTime < 0) {
                window.clearInterval(clock)
                this.content = '发送验证码'
                this.totalTime = 60
                this.canClick = true //这里重新开启
            }
        }, 1000)
    },
  }
};
</script>

<style >
</style>
